// extracted by mini-css-extract-plugin
export default {"content":"Modal_content__AFonr","modalHeader":"Modal_modalHeader__DEqVH","modalBody":"Modal_modalBody__TO7rh","modalFooter":"Modal_modalFooter__mH1II"};